<template>
  <text :y="y ? y : `${-((parts.length - 1) * .5)}em`" v-if="parts">
    <tspan class="tspan-wrapper" v-for="(part, index) in parts" :key="index" :x="x" :dy="index > 0 ? '1.25em' : 0">{{ part }}</tspan>
  </text>
</template>

<script>
export default {
  name: 'WrappedText',
  props: {
    content: String,
    x: Number,
    y: Number,
  },
  computed: {
    parts() {
      return this.content ? this.content.split('¤') : null;
    }
  },
}
</script>

<style lang="scss">
.tspan-wrapper {
  letter-spacing: -0.01em;
}
.axis--y .tick text {
  transform: translate(4px, 0);
}
</style>
